module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x15-ff47c55724781fa4fbe5b50071d23809.png";